var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button',{attrs:{"label":_vm.label,"running":_vm.running,"icon":"fa fa-download","text":"","no-uppercase":""},on:{"click":_vm.download}})}
var staticRenderFns = []

export { render, staticRenderFns }